/*
  Страница присланных файлов для таблицы вкладки «Файлы» (21.10.2026).

  Требование владельца: пагинация серверная. Таблица просит у сервера окно файлов
  (`limit`, `offset`) и получает `{ items, total }`; панель - общая (`PageBar`), хук -
  общий (`usePagedList`). Опрос вкладки (`useUploads`) окна не знает: он спрашивает
  про все файлы разом, а эта страница перечитывается, когда он сообщает, что что-то
  изменилось, - меняется `stamp` (файл добавлен, прочитан, удалён, кончился перенос или
  человек что-то сделал).
*/

import { useCallback } from 'react'

import { api } from '../../api/client.js'
import usePagedList from '../usePagedList.js'
import useReloadOn from '../useReloadOn.js'

export default function useFilesPage(stamp) {
  const load = useCallback((window) => api.uploads(window), [])
  const page = usePagedList(load)
  useReloadOn(stamp, page.reload)
  return page
}
